
<template>
  <div class="bind-bankbox">
    <div class="card-box">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: bold">{{
            $t("RewardCenter.BindBankAcc.Title")
          }}</span>
        </div>
        <div class="tip-box">
          <div>{{ $t("RewardCenter.BindBankAcc.Tip") }}</div>
        </div>
        <div class="contents-box">
          <el-row :gutter="20" style="line-height: 2">
            <el-col :span="10">
              <div class="lb">
                {{ $t("RewardCenter.BindBankAcc.AccountName") }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="inp">
                <CInput
                  v-model="bindObj.Bank.AccountName"
                  oninput="value=value.replace(/[^a-zA-Z\u4E00-\u9FA5\' ']/g, '')"
                  type="text"
                />
              </div>
            </el-col>
            <el-col :span="10">
              <div class="lb">
                {{ $t("RewardCenter.BindBankAcc.AccountNumber") }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="inp">
                <CInput v-model="bindObj.Bank.AccountNumber" type="number" />
              </div>
            </el-col>
            <el-col :span="10">
              <div class="lb">
                {{ $t("RewardCenter.BindBankAcc.BankName") }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="inp">
                <CInput
                  v-model="bindObj.Bank.BankName"
                  type="text"
                  oninput="value=value.replace(/[^a-zA-Z\u4E00-\u9FA5\' ']/g, '')"
                />
              </div>
            </el-col>
            <el-col :span="10">
              <div class="lb">
                {{ $t("RewardCenter.BindBankAcc.BankCode") }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="inp">
                <CInput v-model="bindObj.Bank.BankCode" type="text" />
              </div>
            </el-col>
            <el-col :span="10">
              <div class="lb">
                {{ $t("RewardCenter.BindBankAcc.SwiftCode") }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="inp">
                <CInput v-model="bindObj.Bank.SwiftCode" type="text" />
              </div>
            </el-col>
          </el-row>
          <div style="margin-top: 1rem">
            <button
              @click="submitBankAcc"
              class="btn custer sbtn"
              type="button"
            >
              {{ $t("RewardCenter.TransferToAcc.TransferConfirm") }}
            </button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
export default {
  data() {
    return {
      bindObj: {
        Bank: {
          AccountName: "",
          AccountNumber: "",
          BankName: "",
          BankCode: "",
          SwiftCode: "",
        },
      },
    };
  },
  methods: {
    // 提交绑定银行账户
    submitBankAcc() {
      if (
        this.bindObj.Bank.AccountName == "" ||
        this.bindObj.Bank.AccountNumber == "" ||
        this.bindObj.Bank.BankName == ""
      ) {
        return;
      }
      // process.env.VUE_APP_BASE_URL+"/request/user.php"
      let loading = Loading.service({ fullscreen: true });
      this.$axios({
        method: "POST",
        url: `/request/user.php?type=bind_agent_withdraw_acc&uid=${localStorage.getItem(
          "uid"
        )}`,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        data: JSON.stringify(this.bindObj),
      }).then((res) => {
        if (res.data.code == 200) {
          loading.close();
          this.$message.success(res.data.message);
          this.$router.push("/reward-center/account");
        } else if (res.data.code == 401) {
          loading.close();
          this.$message.warning(res.data.message);
          this.$router.push("/pages/login");
        } else {
          loading.close();
          this.$message({
            type: "error",
            message: res.data.message,
            duration: 5000,
          });
        }
      });
    },
  },
};
</script>


<style scoped>
.bind-bankbox {
  padding-left: 2.6rem;
}
.card-box {
  width: 83%;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.contents-box {
  width: 420px;
  margin: 1rem auto;
}
.citem {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.form-group {
  margin: 0;
}
.lb {
  text-align: right;
  color: rgb(66, 71, 77);
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.inp {
  margin-left: 30px;
  margin-bottom: 0.88rem;
}
.tip-box {
  padding: 10px 20px;
  background: #fdf6ec;
  color: #e6aa6f;
  text-align: center;
  font-size: 14px;
}
.sbtn:hover {
  background: rgba(0, 190, 164, 0.8) !important;
}
.sbtn:focus {
  border-color: #00bea4;
  box-shadow: 0 0 0 0.25rem rgba(0, 190, 164, 0.5) !important;
}
.custer {
  background: #00bea4;
  color: #fff;
  width: 100%;
  outline: 0;
}
</style>